import Compressor from "compressorjs";

import { generateId } from "base/utils";
import { FILE_PREVIEW_EXTENSIONS } from "base/constants";

import {
  ATTACH,
  IMAGE_MIME_TYPE,
  COMPRESSION_EXTENSION
} from "../filepicker.constant";
import { Upload } from "./upload";
import {
  computeFileDurationLength,
  getFileExtension,
  objectURL
} from "./extensions.utils";
import { Progress } from "./progress";
import { getMaxDimension } from "./picker.utils";
import { FileValidation } from "./filepicker.validation";

let _uploadInstance;
let abortRequestList = {};

export class FileWrapper {
  constructor(file, baseURL, uploadURL, config, prefix) {
    this.file = file;
    this.baseURL = baseURL;
    this.uploadURL = uploadURL;
    this.config = config;
    this.prefix = prefix;
    this.file.id = generateId(ATTACH);
    this.fileMetaData(file);
    this.onFileProgress = () => {};
    this.successCb = () => {};
  }

  onProgress = (cb = () => {}) => {
    this.onFileProgress = cb;
  };

  onResponseDone = (cb = () => {}) => {
    this.successCb = cb;
  };

  cancelUpload = () => {
    _uploadInstance?.cancelFile(this.file);
  };

  onFileCompression = (file, width, height) => {
    let compressedFile = {
      width: width,
      height: height,
      quality: 0.6,
      maxWidth: 4096,
      maxHeight: 4096,
      minWidth: 100,
      minHeight: 100,
      convertSize: 5000000,
      success: (blob) => {
        var fileFromBlob = new File([blob], blob.name, {
          lastModified: blob.lastModified,
          type: blob.type
        });
        this.fileMetaData(fileFromBlob);
        fileFromBlob.id = file.id;
        this.onUploadLocalFile(fileFromBlob);
        compressedFile.compression = true;
      }
    };
    this.file.progress.stopProgress();
    return compressedFile;
  };

  fileMetaData = (file) => {
    file.mimeType = file.type;
    file.fileExtension = getFileExtension(file?.name);
    file.progress = new Progress((progress) => {
      this.progess = progress;
      this.onFileProgress(progress);
    });
    if (IMAGE_MIME_TYPE.includes(file.mimeType)) {
      file.thumbnailImg = objectURL(file);
    }
  };

  validate = () => {
    this.file.validation = new FileValidation(this.config, this.file);
    let isError = this.file.validation.validate();
    return isError;
  };

  getSelectedFiles = async () => {
    if (
      FILE_PREVIEW_EXTENSIONS.AUDIO_FORMATS.includes(this.file.fileExtension)
    ) {
      const { duration } = await computeFileDurationLength(this.file);
      this.file.duration = duration;
    }
    let isError = this.validate();
    const allowedImgExtension = this.config.fileExtensions.includes("*")
      ? COMPRESSION_EXTENSION
      : COMPRESSION_EXTENSION.filter((ext) =>
          ext.includes(this.config.fileExtensions)
        );
    const _fileExtension =
      allowedImgExtension.includes(this.file.fileExtension) &&
      this.config?.compression;
    if (isError === true) {
      this.file.progress.asyncProgress(0, 25, 200);
      if (_fileExtension) {
        getMaxDimension(this.file).then((width, height) => {
          const optionsConfig = this.onFileCompression(
            this.file,
            width,
            height
          );
          let compressabort = new Compressor(this.file, optionsConfig);
          abortRequestList[this.file.id] = () => compressabort.abort();
        });
      } else {
        abortRequestList[this.file.id] = null;
        this.onUploadLocalFile(this.file);
        this.file.compression = false;
      }
    } else {
      this.file.fileError = true;
      this.file.Error = isError;
      if (!this.file.validation.isValid()) {
        this.file.err_status = 400;
      }
      this.successCb(this);
    }
  };

  retryUpload = () => {
    this.file.fileError = false;
    this.file.Error = "";
    this.file.retry = true;
    this.onUploadLocalFile(this.file);
    this.file.progress = new Progress((progress) => {
      this.progess = progress;
      this.onFileProgress(progress);
    });
    abortRequestList[this.file.id] = null;
  };

  onUploadLocalFile = async (file) => {
    _uploadInstance = new Upload(
      file,
      this.prefix,
      this.config,
      abortRequestList,
      this.cancelUpload
    );
    _uploadInstance.upload(this.uploadURL, (err, response) => {
      if (response) {
        this.successCb(response);
      } else if (err) {
        this.file.fileError = true;
        this.file.Error = err.en_message || "upload Failed";
        this.successCb(this);
        this.file.progress.stopProgress();
      }
    });
    return this;
  };
}
